import React from 'react';

import {
	INSERT_BLOCK_SECTION,
	SYNCED_BLOCK_BUTTON,
	SYNCED_BLOCK_GROUP,
} from '@atlaskit/editor-common/toolbar/keys';
import {
	INSERT_BLOCK_SECTION_RANK,
	SYNCED_BLOCK_SECTION_RANK,
} from '@atlaskit/editor-common/toolbar/rank';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { RegisterComponent } from '@atlaskit/editor-toolbar-model/types';
import { Show } from '@atlaskit/editor-toolbar/show';
import { ToolbarButtonGroup } from '@atlaskit/editor-toolbar/toolbar-button-group';

import type { SyncedBlockPlugin } from '../syncedBlockPluginType';
import { CreateSyncedBlockButton } from './CreateSyncedBlockButton';

const SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP = {
	type: SYNCED_BLOCK_GROUP.type,
	key: SYNCED_BLOCK_GROUP.key,
	component: ({ children }: { children: React.ReactNode }) => (
		<Show above="md">
			<ToolbarButtonGroup>{children}</ToolbarButtonGroup>
		</Show>
	),
	parents: [
		{
			type: INSERT_BLOCK_SECTION.type,
			key: INSERT_BLOCK_SECTION.key,
			rank: INSERT_BLOCK_SECTION_RANK[SYNCED_BLOCK_GROUP.key],
		},
	],
};

export const getToolbarComponents = (
	api?: ExtractInjectionAPI<SyncedBlockPlugin>,
	enableSourceSyncedBlockCreation?: boolean,
): RegisterComponent[] => {
	if (!enableSourceSyncedBlockCreation) {
		return [];
	}

	return [
		SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP,
		{
			type: SYNCED_BLOCK_BUTTON.type,
			key: SYNCED_BLOCK_BUTTON.key,
			component: () => <CreateSyncedBlockButton api={api} />,
			parents: [
				{
					type: SYNCED_BLOCK_GROUP.type,
					key: SYNCED_BLOCK_GROUP.key,
					rank: SYNCED_BLOCK_SECTION_RANK[SYNCED_BLOCK_BUTTON.key],
				},
			],
		},
	];
};
